import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class Checkbox extends React.Component {
  static propTypes = {
    field: PropTypes.object
  }

  renderBlank() {
    return <div className={styles.container}>Checkbox</div>
  }

  render() {
    if (!this.props.field) return this.renderBlank()
    let checked = true
    if (!this.props.field.value || !this.props.field.value.checked) {
      checked = false
    }
    return (
      <div className={styles.container}>
        <div style={{position: 'absolute', width: '100%', height: '100%'}} />
        <input type="checkbox" disabled checked={checked} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/Field/Checkbox/index.js